import { render, staticRenderFns } from "./SMSTemplateList.vue?vue&type=template&id=1d704e3f&"
import script from "./SMSTemplateList.vue?vue&type=script&lang=js&"
export * from "./SMSTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports